import { render, staticRenderFns } from "./EtransactElectricity.vue?vue&type=template&id=33406317&scoped=true"
import script from "./EtransactElectricity.vue?vue&type=script&lang=js"
export * from "./EtransactElectricity.vue?vue&type=script&lang=js"
import style0 from "./EtransactElectricity.vue?vue&type=style&index=0&id=33406317&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33406317",
  null
  
)

export default component.exports